import { getCatalogCategories } from '@/dashboards-v2/constants/catalog-categories.constants';
import { AppsService } from '@/common/apps/apps.service';
import { RANGE_LAST_30_DAYS } from '@/dashboards-v2/constants/default-date-range';

const { ALL_AGG_ID } = AppsService;

const DEFAULT_METADATA_DEFINITION = Object.freeze({
    dateRange: RANGE_LAST_30_DAYS,
    metadata: undefined,
    segmentId: 'everyone',
    appId: ALL_AGG_ID,
});

const getMetadataWidgetBase = (name = 'Metadata Details') => ({
    name,
    type: 'metadataDetails',
});

export const getDefaultMetadataWidget = (overrides = {}, name) => ({
    ...getMetadataWidgetBase(name),
    definition: {
        ...DEFAULT_METADATA_DEFINITION,
        ...overrides,
    },
});

export const METADATA_WIDGET_CATALOG_SETTINGS = Object.freeze({
    ...getMetadataWidgetBase(),
    settings: DEFAULT_METADATA_DEFINITION,
    image: 'metadata-details.png',
    hideFromMenu: true,
    categories: [getCatalogCategories().SYSTEM],
});
